import { createContext, useContext } from "react";
import React from "react";

export type ResizeStrategy = "resize-neighbors" | "resize-all";
export type ColumnWidth = number | string;

export type ToggleMeasureBranch = "controlled" | "fallback" | "single";

export interface ResizableColumnRegistration {
    id: string;
    width: ColumnWidth;
    minWidth?: number;
    maxWidth?: number;
    autoSizeFromToggle?: boolean;
    showSeparator?: boolean;
}

export interface ResizableColumnControllerContextValue {
    registerColumn: (registration: ResizableColumnRegistration) => void;
    unregisterColumn: (id: string) => void;
    updateColumn: (registration: ResizableColumnRegistration) => void;
    reportMeasuredToggleWidth: (columnId: string, measuredWidthPx: number, branch: ToggleMeasureBranch) => void;
    getColumnWidth: (id: string) => number;
    getColumnPercentage: (id: string) => number;
    getSeparatorProps: (index: number) => {
        role: "separator";
        tabIndex: number;
        "aria-orientation": "vertical";
        "aria-label": string;
        "aria-controls": string;
        "aria-valuemin": number;
        "aria-valuemax": number;
        "aria-valuenow": number;
        onPointerDown: (event: React.PointerEvent<HTMLDivElement>) => void;
        onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
    };
    getColumnIdByIndex: (index: number) => string | null;
}

export const ResizableColumnControllerContext = createContext<ResizableColumnControllerContextValue | null>(null);

export function useResizableColumnController(): ResizableColumnControllerContextValue | null {
    return useContext(ResizableColumnControllerContext);
}
